module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_sp_f46cc09a54fb978071c6a60585ff73cf.jpg";